module.exports = __webpack_public_path__ + "img/2021年7月2日庆贺广州冰眸电子有限公司成立62.08d539c6.jpg";